module.exports = __webpack_public_path__ + "img/artboard3.4493486f.png";